import { EVENT_TYPES } from '../../constants';

const updateFilters = (state, { types, visible }) => {
  let nextState = [];
  if (visible) {
    nextState = [...state, ...types];
  } else {
    nextState = state.filter(id => !types.includes(id));
  }
  return nextState;
};

export const modal = (state = null, action) => {
  switch (action.type) {
    case EVENT_TYPES.MODAL_OPEN:
      return action.payload;
    case EVENT_TYPES.MODAL_CLOSE:
      return false;
    default:
      return state;
  }
};

export const filters = (state = [], action) => {
  switch (action.type) {
    case EVENT_TYPES.FILTERS_CHANGE:
      return updateFilters(state, action.payload);
    default:
      return state;
  }
};

export const navigation = (state = null, action) => {
  switch (action.type) {
    case EVENT_TYPES.NAVIGATION_TOGGLE:
      return action.payload;
    default:
      return state;
  }
};

export const editMode = (state = false, action) => {
  switch (action.type) {
    case EVENT_TYPES.EDITMODE_TOGGLE:
      return !state;
    case EVENT_TYPES.EDITMODE_ENABLED:
      return true;
    case EVENT_TYPES.EDITMODE_DISABLED:
      return false;
    default:
      return state;
  }
};

export const lastCenter = (state = [0, 0], action) => {
  switch (action.type) {
    case EVENT_TYPES.LASTCENTER_UPDATE:
      return action.payload;
    default:
      return state;
  }
};

export const lastActivity = (state = null, action) => {
  switch (action.type) {
    case EVENT_TYPES.TODO_TOGGLE:
    case EVENT_TYPES.FILTERS_CHANGE:
    case EVENT_TYPES.MARKERS_LOADED:
    case EVENT_TYPES.LASTCENTER_UPDATE:
      return Date.now();
    default:
      return state;
  }
};

export const loading = (state = true, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export const appready = (state = false, action) => {
  switch (action.type) {
    case EVENT_TYPES.MARKERS_LOADED:
      return true;
    default:
      return state;
  }
};
